<template>
  <div class="index-box">
    <div class="fixed-box" id="aaa">
      <!-- <banner /> -->
      <navComponent />
    </div>
    <div class="scroll-box" style="margin-top: 0">
      <div class="bg">
        <div class="scroll-item">

          
          <!-- 课程介绍 -->
          <div class="title" id="kechengjieshaoBlock">
            <span>课程介绍</span>
          </div>
          <kechengjieshao />

          <!-- 业务板块 -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title01.png" //> -->
            <span>业务板块</span>
          </div>
          <courseList />
          <!-- 音乐剧介绍 -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title01.png" //> -->
            <span>音乐剧介绍</span>
          </div>
          <musicalIntroduction />

          <!-- 品牌优势 -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title02.png" /> -->
            <span>企业实力/核心优势</span>
          </div>
          <div class="advantage-flex">
            <div
              v-for="(item, index) in advantageList"
              :key="index"
              class="advantage-item fadeInUp wow"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <div class="advantage-img">
                <img :src="item.img" />
              </div>
              <div class="advantage-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <!-- 师资力量  -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title03.png" /> -->
            <span>自营机构</span>
          </div>
          <div class="swiper-container swiper-container-teacher">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in 9"
                :key="index"
                class="swiper-slide teacher-item"
              >
                <img
                  :src="
                    require(`@/assets/home_image/teacher/huashiqiyejieshao_page-00${
                      index + 1
                    }.jpg`)
                  "
                  alt=""
                />
                <!-- <div class="teacher-desc">
                  <p v-for="(k, i) in item.desc" :key="i">{{ k }}</p>
                </div> -->
              </div>
            </div>
            <div class="fenye">
              <div class="swiper-button-teacher-prev"></div>
              <div class="swiper-pagination swiper-pagination-teacher" />

              <div class="swiper-button-teacher-next"></div>
            </div>
          </div>
          <!-- 荣誉奖项 -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title04.png" /> -->
            <span>荣耀成绩</span>
          </div>

          <div class="reward-container">
            <div v-for="(item, index) in rewardList" :key="index">
              <img
                class="reward-img"
                :src="
                  require(`@/assets/home_image/teacher/huashiqiyejieshao_page-00${
                    index + 4
                  }.jpg`)
                "
                alt="奖项"
              />

              <img
                class="reward-line"
                src="@/assets/home_image/reward/line.png"
                alt="奖项连接线"
                v-if="rewardList.length - 1 !== index"
              />
            </div>
          </div>
          <!-- 千尺动态 -->
          <div class="title">
            <!-- <img src="@/assets/home_image/title05.png" /> -->
            <span>动态</span>
          </div>

          <div class="news-container">
            <div
              v-for="(item, index) in newsList"
              :key="index"
              class="news-item"
            >
              <a :href="item.link" class="news-title">{{ item.title }}</a>
              <div class="news-desc">{{ item.text }}</div>
              <a class="goto-news" :href="item.link"
                ><img src="@/assets/home_image/tiaozhuanjiao.png"
              /></a>
            </div>
          </div>
          <!-- <img
            class="paint-bg"
            src="@/assets/home_image/paint-bg.eedec373.png"
          /> -->
        </div>
      </div>
      <footerComponent />
    </div>
  </div>
</template>
<script setup>
import navComponent from "@/components/nav";
import banner from "@/components/banner";
import footerComponent from "@/components/footer";
import { onMounted,ref,nextTick } from "vue";
//课程体系
import courseList from "./components/courseList";

//音乐剧介绍
import musicalIntroduction from "./components/musicalIntroduction";

//课程介绍
import kechengjieshao from "./components/kechengjieshao";
//优势列表
import advantageImg1 from "@/assets/logo.png";
import advantageImg2 from "@/assets/logo1.png";
import advantageImg3 from "@/assets/logo.png";
import advantageImg4 from "@/assets/logo1.png";
// 师资力量

//荣誉奖项
import reward01 from "@/assets/home_image/reward/reward01.png";
import reward02 from "@/assets/home_image/reward/reward02.png";
import reward03 from "@/assets/home_image/reward/reward03.png";
import reward04 from "@/assets/home_image/reward/reward04.png";
import reward05 from "@/assets/home_image/reward/reward05.png";
const lian = ref({})
console.log(lian)
//优势列表
const advantageList = [
  {
    title: "专业艺术媒体团队",
    desc: "成功发行多手流行歌曲，为多个企业和组织打造宣传视频和音乐视频，打造视听一流的音乐剧，舞台剧",
    img: advantageImg1,
  },
  {
    title: "顶尖视频和音乐团队/中国好声音合作音乐机构",
    desc: "为多家五百强企业设计和实施培训课程与项目",
    img: advantageImg2,
  },
  {
    title: "承办赛事",
    desc: "2003中国好声音北京赛区歌唱比赛承办单位；",
    img: advantageImg3,
  },
  {
    title: "顶尖培训教研团队/中国传媒大学战略合作机构",
    desc: "为多家五百强企业设计和实施培训课程与项目",
    img: advantageImg4,
  },
];
//师资列表
const teacherList = [];

//奖项列表
const rewardList = [
  {
    id: 1,
    reward: reward01,
  },
  {
    id: 2,
    reward: reward02,
  },
  {
    id: 3,
    reward: reward03,
  },
  {
    id: 4,
    reward: reward04,
  },
  {
    id: 5,
    reward: reward05,
  },
];

//千尺动态
const newsList = [
  // {
  //   title: "量子之歌登陆纳斯达克",
  //   text: "近日，量子之歌集团（股票代码“QSG”）正式在美国纳斯达克上市，成为2023年首家登陆美股的中国企业。量子之歌集团创始人、董事长、CEO李鹏发表开场致辞表示：“量子之歌正在做的事业，是通过学习帮助大众提升认知，并且在这个过程中……",
  //   link: "http://www.jjckb.cn/2023-01/30/c_1310693706.htm",
  // },
  {
    title: "中老年兴趣学习平台花世企业：以适老化在线课程帮助用户实现自我发展",
    text: "随着“适老”逐渐成为“互联网+”时代的热点关键词，关于什么是“高品质老年生活”、“如何为银发族打造高品质晚年生活”等话题也成为公众普遍关注的焦点……",
    link: "https://caijing.chinadaily.com.cn/a/202302/02/WS63db25cda3102ada8b22d6b3.html",
  },
  {
    title: "乌镇峰会聚焦数字未来 花世企业帮助中老年人融入数字社会",
    text: "11月9日，由世界互联网大会主办、浙江省人民政府承办的2022年世界互联网大会乌镇峰会，在浙江乌镇隆重启幕本届峰会以“共建网络世界……",
    link: "https://www.zgswcn.com/article/202211/202211101605181085.html",
  },
  // {
  //   title: '千尺：花世企业开设在线兴趣艺术课程 推动践行积极老龄观',
  //   text: '在终身学习理念的推动下，不少中老年人退休后来到老年大学学习才艺和技能。他们中的很多人选择通过举办书画展，作为自己的“毕业设计”，展示自己的学习成果……',
  //   link: 'https://finance.ifeng.com/c/8K55vk8TCvR'
  // },
  // {
  //   title: '千尺：花世企业亮相智慧康养高峰论坛 以线上化教学助力实现“积极老龄观”',
  //   text: '9月2日，由北京老龄工作委员会办公室、北京市老龄协会和北京商报社共同主办的“2022智慧康养高峰论坛”在服贸会北京首钢园举行。会议以“康养新模式 老龄大健康”为主题，汇聚了政、医、学、企各界……',
  //   link: 'https://biz.huanqiu.com/article/49UXUhKwQJF'
  // },
  // {
  //   title: '传习中国画艺 花世企业国画课让中老年人品……',
  //   text: '央广网北京7月20日消息，别以为只有年轻人才追求“高学历”，现如今上大学、学技能、考学位也成为了很多中老年人的生活追求。在上海，70岁的徐奶奶从2013年被中国美术学院大专班录取开始，连续拿到书法专业大专与本科毕业证，去年又从中国美术学院中国画专业顺利毕业，拿到了自己的第二个艺术……',
  //   link: 'http://edu.cnr.cn/eduzt/jylt/jd/yw/20220720/t20220720_525923904.shtml'
  // },
  // {
  //   title: '花世企业：以适老化的教学方式让老人享受……',
  //   text: '近日有报道称，预计从现在开始至未来10年，我国将迎来史上最大“退休潮”。“60后”群体正以每年2000万人的速度退休，但与“传统老人”不同的是，由于教育程度、收入水平与消费水平更高，他们以鲜明的特征，塑造了一个新的群体标签。对于退休生活，他们拥有更高的追求，渴望更富足的精神生……',
  //   link: 'http://www.jjckb.cn/2022-07/12/c_1310640711.htm#10006-weixin-1-52626-6b3bffd01fdde4900130bc5a2751b6d1'
  // },
  // {
  //   title: '2022全球数字经济大会开幕 中老年兴趣学习平台花世企业受邀参加',
  //   text: '7月28日,2022全球数字经济大会正式启幕。会议由北京市人民政府、国家发展和改革委员会、工业和信息化部、商务部、国家互联网信息办公室、中国科学技术协会共同主办,以“启航数字文明——新要素、新规则、新格局”为主题,邀请了全球30余个国家及地区参与,共话数字经济……',
  //   link: 'https://caijing.chinadaily.com.cn/a/202207/29/WS62e36d78a3101c3ee7ae15d7.html'
  // },
];

const initTeacherSwiper = () => {
  const swiperHandleBanner = new Swiper(".swiper-container-teacher", {
    effect: "slide",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
    //如果需要分页器
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    //如果需要前进后退按钮
    navigation: {
      nextEl: ".swiper-button-teacher-next",
      prevEl: ".swiper-button-teacher-prev",
    },
  });
  swiperHandleBanner.show = () => {};
};
onMounted(() => {
  initTeacherSwiper();
//   setTimeout(()=>{
//     nextTick(()=>{

//  // 获取目标元素（锚点）
//  var targetElement = document.getElementById("kechengjieshaoBlock"); // 这里需要根据实际情况修改为正确的id或class名称
 
//  // 判断目标元素是否存在
//  if (targetElement) {
//      // 设置滚动行为参数
//      var scrollOptions = { behavior: "instant", block: "start" };
     
//      // 执行滚动操作
//      targetElement.scrollIntoView(scrollOptions);
//  } else {
//      console.log("未找到目标元素！");
//  }
// })

//   })
 
});
</script>
<style lang="scss" scoped>
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.index-box {
  position: relative;

  .bg {
    // height: 3680px;
    // background-image: url('../assets/home_image/background_image/bg.png')
    // background-size: 100% 100%;
    // z-index: 100;
    position: relative;
    margin-top: -1px;
  }

  .scroll-box {
    margin-top: 850px;
    background-image: url("../assets/home_image/background_image/bg.png");
    background-size: 100% 100%;
    z-index: 100;
    position: relative;

    //卷轴
    .scroll-item {
      width: 1440px;
      // height: 3870px;
      // position: absolute;
      position: relative;
      left: calc(50% - 720px);
      // top: -40px;
      padding-top: 100px;
      // background-image: url("~@/assets/home_image/background_image/scroll.png");
      background-size: 100% 100%;
      z-index: 100;
      .title {
        // height: 92px;
        // line-height: 90px;
        text-align: center;
        margin: 0 auto;
        color: #fff;
        img {
          width: 100%;
        }
        span {
          font-size: 32px;
          font-weight: 900;
        }
      }
    }
  }
  //课程体系
  .course-flex {
    width: 918px;
    height: 200px;
    margin: 50px auto 67px;
    display: flex;
    justify-content: space-around;
    .course-item {
      width: 178px;
      height: 178px;
      background-size: 100% 100%;
      transition: all 0.2s linear;
      position: relative;
      cursor: pointer;
    }
    .course-item:hover {
      transform: scale(1.06);
      transition: all 0.2s linear;
      -webkit-font-smoothing: antialiased;
    }
    .course-item-ro-0 {
      -webkit-transition-property: -webkit-transform;
      -webkit-transition-duration: 10s;
      -moz-transition-property: -moz-transform;
      -moz-transition-duration: 10s;
      -webkit-animation: rotate 10s linear infinite;
      -moz-animation: rotate 10s linear infinite;
      -o-animation: rotate 10s linear infinite;
      animation: rotate 10s linear infinite;
    }
    .course-item-ro-1 {
      -webkit-transition-property: -webkit-transform;
      -webkit-transition-duration: 10s;
      -moz-transition-property: -moz-transform;
      -moz-transition-duration: 10s;
      -webkit-animation: rotate 10s linear infinite;
      -moz-animation: rotate 10s linear infinite;
      -o-animation: rotate 10s linear infinite;
      animation: rotate 10s linear infinite;
    }
    .course-item-ro-2 {
      -webkit-transition-property: -webkit-transform;
      -webkit-transition-duration: 10s;
      -moz-transition-property: -moz-transform;
      -moz-transition-duration: 10s;
      -webkit-animation: rotate 10s linear infinite;
      -moz-animation: rotate 10s linear infinite;
      -o-animation: rotate 10s linear infinite;
      animation: rotate 10s linear infinite;
    }
    .course-item-ro {
      animation-play-state: paused;
    }
    .course-item-ro {
      position: absolute;
      z-index: -1;
      width: 178px;
      height: 178px;
      // background-image: url("../assets/home_image/background_image/course-circular.png");
      // transition: all 10s linear;
      background-repeat: no-repeat;
    }
    .course-img {
      width: 220px;
      height: 126px;
      position: absolute;
      top: calc(50% - 63px);
      left: calc(50% - 110px);
      // background-image: url("../assets/home_image/background_image/course-block.png");
      background-size: 100% 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      img {
        width: 188px;
        height: 91px;
        margin-top: -4px;
      }
    }
    .course-title {
      width: 200px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: bold;
      color: #222222;
      position: absolute;
      bottom: -31px;
      cursor pointer img {
        margin-left: 5px;
      }
    }
  }
  //品牌优势
  .advantage-flex {
    width: 1028px;
    height: auto;
    margin: 40px auto 60px;
    display: flex;
    flex-flow: wrap;
    // justify-content: space-between;
    .advantage-item {
      width: 493px;
      height: 147px;
      flex: 0 0 1;
      padding-left: 60px;
      display: flex;
      align-items: center;
      background-image: url("../assets/home_image/background_image/advantage-bg.png");
      background-size: 100% 100%;
      position: relative;
      margin-bottom: 37px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all 0.3s linear;
      -webkit-font-smoothing: antialiased;
      .advantage-img {
        img {
          width: 100px;
        }
      }
      .advantage-content {
        padding: 27px;
        h3 {
          font-size: 18px;
          font-weight: 900;
          color: #222222;
          margin-bottom: 13px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: #222222;
          line-height: 20px;
          text-align: justify;
        }
      }
    }
    .advantage-item:hover {
      transform: perspective(1px) scale(1.06);
      transition: all 0.3s linear;
      -webkit-font-smoothing: antialiased;
    }
    .advantage-item:nth-child(odd) {
      margin-right: 37px;
    }
  }
  //师资力量
  .swiper-container-teacher {
    width: 882px;
    position: relative;
    margin-bottom: 60px;
    margin-top: 40px;
    .teacher-item {
      width: 882px;
      box-sizing: border-box;
      position: relative;
      img {
        width: 100%;
      }
    }
    .fenye {
      position: absolute;
      bottom: 10px !important;
      width: 100%;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .swiper-pagination-teacher {
        position: relative;
        margin: 0 20px;
        :deep() {
          .swiper-pagination-bullet {
            width: 40px !important;
          }
          .swiper-pagination-bullet-active {
            background: #ceb272 !important;
          }
        }
      }
      .swiper-button-teacher-prev {
        width: 36px;
        height: 18px;
        display: inline-block;
        background-image: url("~@/assets/home_image/background_image/prev.png");
        z-index: 1000;
        cursor: pointer;
      }
      .swiper-button-teacher-next {
        width: 36px;
        height: 18px;
        display: inline-block;
        background-image: url("~@/assets/home_image/background_image/next.png");
        z-index: 1000;
        cursor: pointer;
      }
    }
  }
  .reward-container {
    width: 1000px;
    // height: 134px;
    margin: 40px auto 60px;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    div {
      display: inline-block;
      .reward-img {
        width: 240px;
        // height: 134px;
      }
      .reward-line {
        position: relative;
        top: -58px;
        width: 74px;
        height: 18px;
      }
    }
  }

  //千尺动态
  .news-container {
    width: 978px;
    height: 477px;
    margin: 40px auto 60px;
    background-image: url("../assets/home_image/background_image/news-bg.png");
    background-size: 100% 100%;
    padding: 50px;
    box-sizing: border-box;

    .news-item {
      padding: 30px 0;
      position: relative;
      border-top: 1px dashed #a9b7c3;
      .news-title {
        font-size: 18px;
        font-weight: 900;
        display: block;
        color: #222222;
        line-height: 24px;
        margin-bottom: 14px;
      }
      .goto-news {
        width: 6px;
        height: 12px;
        position: absolute;
        bottom: 30px;
        right: 0;
      }
    }

    .news-item:first-child {
      border-top: none;
    }
  }
  // .paint-bg {
  //   width: 926px;
  //   height: 200px;
  //   margin: 0 auto;
  //   position: absolute;
  //   bottom: 172px;
  //   left: calc(50% - 463px);
  //   z-index: 101;
  // }
}

:deep() {
  .swiper-container .swiper-slide {
    width: 100%;
  }

  .swiper-container .swiper-slide img {
    width: 100%;
    height: auto;
    vertical-align: bottom;
  }

  .swiper-container .swiper-slide .bannerplay {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    width: 97px;
    height: 97px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -48px;
    margin-left: -48px;
    z-index: 9;
  }

  .swiper-container .swiper-slide .bannerplay:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .swiper-container .swiper-pagination {
    text-align: left;
  }

  .swiper-container .swiper-pagination-bullet {
    width: 48px;
    height: 6px;
    border-radius: 4px;
    background: rgba(59, 58, 67, 0.2);
    opacity: 1;
  }

  .swiper-container .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #fff;
  }
}

.video-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  min-width: 1200px;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.show-video {
  visibility: visible;
  opacity: 1;
}

video {
  outline: none;
}

.breath_light {
  width: 951px;
  height: 466px;
  animation-name: breath;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;

  -webkit-animation-name: breath;
  -webkit-animation-duration: 1s;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

@keyframes breath {
  from {
    opacity: 0.4;
    transform: scale(0.4);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
